export default __webpack_public_path__ + "static/media/words9.3e99e284.png";